<template>
  <div
    data-cy="complete-check"
    :class="[
      {
        '--overlay': overlay,
        '--horizontal': horizontal,
        '--complete': complete
      },
      'collection-item__complete-check p-absolute d-flex align-items-center justify-content-center'
    ]"
  >
    <v-icon icon="check" size="1rem" />
  </div>
</template>

<script>
export default {
  props: {
    complete: { type: Boolean, default: false },
    overlay: { type: Boolean, default: false },
    horizontal: { type: Boolean, default: false }
  }
}
</script>

<style lang="scss" scoped>
@use 'sass:math';

@import "@/assets/styles/variables";

.collection-item__complete-check {
  background: $color-ui--grey-20;
  color: $color-ui--white;
  right: $size--2;
  bottom: 4.5%;
  margin-top: -#{math.div($size--6, 2)};
  height: $size--6;
  width: $size--6;
  border-radius: $size--10;

  &.--overlay {
    top: auto;
    bottom: 3rem;
    right: 0.25rem;
  }

  &.--horizontal {
    right: $size--4;
    top: 50%;
    bottom: 0%;
  }

  &.--complete {
    background: var(--brand-color-hex);
  }
}
</style>
